const initialState = {
  collection: [],
};

export default function reducer(
  state = {
    ...initialState
  },
  action
) {
  switch (action.type) {
    case "FETCH_LOCATIONS":
      return {
        ...state,
        collection: action.data.locations,
      };

    case "RESET":
    case "LOGOUT":
      return {
        ...initialState,
      };

    default:
      return state;
  }
}
